import React, { FC, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DataLoggingContext } from './DataLoggingContext';
import { useDataLogging } from './useDataLogging';
import { LogActionTypes } from './constants';
import { useUser } from '../hooks';
import { useDispatch } from 'react-redux';
import { setSessionId } from '../slices/auth/entity/AuthSlice';

export const DataLoggingContextProvider: FC = ({ children }) => {
  const [sessionId, setInternalSessionId] = useState<string>('');
  const log = useDataLogging();
  const { user } = useUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (sessionId === '') {
      const sessionUuid = uuidv4();
      setInternalSessionId(sessionUuid);
      dispatch(setSessionId(sessionUuid));
    }
    return () => {
      if (user != null) {
        log(LogActionTypes.CLOSE_WEBSITE);
      }
    };
  }, [sessionId, log, user, dispatch]);

  useEffect(() => {
    if (user == null) {
      const sessionUuid = uuidv4();
      setInternalSessionId(sessionUuid);
      dispatch(setSessionId(sessionUuid));
    }
  }, [user, dispatch]);

  return (
    <DataLoggingContext.Provider value={{ sessionId }}>{children}</DataLoggingContext.Provider>
  );
};
